export default __webpack_public_path__ + "cedbe034dd5212929a6cba99ab654e5f.svg";